// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as SS from 'styled-system';
import Box from 'components/Box';
import { BodySmall } from 'components/Text';
import { colors, transition } from '../theme';

const Prefix = styled(Box)`
  cursor: pointer;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 100px 0 18px;
  border-radius: 4px;
  background: ${colors.platinum};
  box-shadow: 0 0 0 2px ${colors.platinum} inset;
  appearance: none;
  border: 0;
  color: ${colors.greyishBrown};
  outline: 0;
  font-size: 18px;
  transition: all ${transition};
  &:focus {
    background: white;
    border: 0;
    box-shadow: 0 0 0 2px ${colors.waterBlue} inset;
  }
`;

const Input = styled(
  React.forwardRef(
    (
      {
        changeHandler,
        onChange: onChangeProp,
        onUpdateValue,
        className,
        id,
        mt,
        mb,
        ml,
        mr,
        mx,
        my,
        pt,
        pb,
        pl,
        pr,
        px,
        py,
        color,
        height,
        width,
        fontSize,
        fontWeight,
        border,
        borderLeft,
        borderRight,
        borderTop,
        borderBottom,
        borderColor,
        borderRadius,
        hasError,
        isValid,
        prefix,
        ...otherProps
      }: {
        changeHandler?: Function,
        onChange?: Function,
        onUpdateValue?: Function,
        className: string,
        id?: string,
        mt: string,
        mb: string,
        ml: string,
        mr: string,
        mx: string,
        my: string,
        pt: string,
        pb: string,
        pl: string,
        pr: string,
        px: string,
        py: string,
        color: string,
        height: string,
        width: string,
        fontSize: string,
        fontWeight: string,
        border: string,
        border: string,
        borderLeft: string,
        borderRight: string,
        borderTop: string,
        borderBottom: string,
        borderColor: string,
        borderRadius: string,
        hasError: string,
        isValid?: boolean,
        prefix?: string,
        ...
      },
      ref
    ) => {
      const onChange = changeHandler
        ? e => {
            changeHandler(e.target.value);
          }
        : onChangeProp;

      return prefix ? (
        <Box
          className={className}
          position="relative"
          display="flex"
          flexDirection="row-reverse"
        >
          <input ref={ref} {...otherProps} onChange={onChange} id={id} />
          <Prefix
            component="label"
            htmlFor={id}
            flex="0 0 auto"
            px="8px"
            display="flex"
            alignItems="center"
            color={colors.battleshipGrey}
            bg={colors.aluminum}
            border={`1px solid ${colors.silver}`}
            borderRight="0"
            borderRadius="4px 0 0 4px"
            transition={`all ${transition}`}
          >
            <BodySmall styleAs="h5">{prefix}</BodySmall>
          </Prefix>
        </Box>
      ) : (
        <input
          ref={ref}
          {...otherProps}
          onChange={onChange}
          id={id}
          className={className}
        />
      );
    }
  )
)`
  ${props => (props.prefix ? 'input' : '&')} {
    margin: 0;
    padding: 11px 1em;
    font: inherit;
    font-size: 18px;
    color: ${colors.charcoalGrey};
    border-radius: ${props => (props.prefix ? '0 4px 4px 0' : '4px')};
    border: solid 1px;
    border-color: ${colors.silver};
    height: 45px;
    width: 100%;
    background-color: ${colors.white};
    transition: all ${transition};
    ::placeholder {
      color: ${colors.middleGrey};
    }
    &:focus {
      outline: 0;
    }
    ${props =>
      props.isValid
        ? `
    border-color: ${colors.turtleGreen};
    box-shadow: 0 0 0 1px ${colors.turtleGreen};
        `
        : `
    &:focus {
      border-color: ${colors.waterBlue};
      box-shadow: 0 0 0 1px ${colors.waterBlue};
      & + ${Prefix} {
        background: ${colors.waterBlue};
        box-shadow: 0 0 0 1px ${colors.waterBlue};
        border-color: ${colors.waterBlue};
        color: white;
      }
    }`}
    ${props =>
      props.hasError &&
      `
      border-color: ${colors.scarlet};
      box-shadow: 0 0 0 1px ${colors.scarlet};
    `}
    &:disabled {
      background-color: ${colors.lightGrey};
    }
    ${SS.width} ${SS.height} ${SS.color} ${SS.space} ${SS.fontSize}
    ${SS.borders} ${SS.borderRadius} ${SS.borderColor};
  }
`;

export default Input;
